import React from "react";
import { useObserver } from "mobx-react-lite";
import {
  Grid,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  TextField,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { AsyncButton } from "components";
import { useStore } from "./Store";
import { useFormStore } from "./FormStore";

interface Props {
  developerId: number;
}

export default ({ developerId }: Props) => {
  const store = useStore();
  const formStore = useFormStore();

  const handleName = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.name = e.target.value;
    },
    [formStore]
  );

  const handleTrackingVendorId = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.trackingVendorId = +e.target.value;
    },
    [formStore]
  );

  const handleIosAppId = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.iosAppId = e.target.value;
    },
    [formStore]
  );

  const handleAndroidAppId = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.androidAppId = e.target.value;
    },
    [formStore]
  );

  const handleRegexpCampaign = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.regexpCampaign = e.target.value;
    },
    [formStore]
  );

  const handleRegexpPubTwitter = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.regexpPubTwitter = e.target.value;
    },
    [formStore]
  );

  const save = React.useCallback(async () => {
    if (await formStore.save(developerId)) {
      store.fetchAppGroups(developerId);
    }
  }, [developerId, formStore, store]);

  return useObserver(() => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="名前"
          value={formStore.value.name || ""}
          error={!!formStore.errors.columns.name}
          helperText={formStore.errors.columns.name}
          onChange={handleName}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="iOS App ID"
          value={formStore.value.iosAppId || ""}
          error={!!formStore.errors.columns.iosAppId}
          helperText={formStore.errors.columns.iosAppId}
          onChange={handleIosAppId}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Android App ID"
          value={formStore.value.androidAppId || ""}
          error={!!formStore.errors.columns.androidAppId}
          helperText={formStore.errors.columns.androidAppId}
          onChange={handleAndroidAppId}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="LayApp キャンペーン名"
          value={formStore.value.regexpCampaign || ""}
          error={!!formStore.errors.columns.regexpCampaign}
          helperText={formStore.errors.columns.regexpCampaign}
          onChange={handleRegexpCampaign}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Twitter 媒体名"
          value={formStore.value.regexpPubTwitter || ""}
          error={!!formStore.errors.columns.regexpPubTwitter}
          helperText={formStore.errors.columns.regexpPubTwitter}
          onChange={handleRegexpPubTwitter}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl>
          <FormLabel>計測ベンダー</FormLabel>
          <RadioGroup>
            {formStore.trackingVendors.map((trackingVendor) => (
              <FormControlLabel
                key={`tracking-vendors-${trackingVendor.id}`}
                label={trackingVendor.name}
                control={
                  <Radio
                    value={trackingVendor.id}
                    checked={
                      formStore.value.trackingVendorId === trackingVendor.id
                    }
                    onChange={handleTrackingVendorId}
                  />
                }
              />
            ))}
          </RadioGroup>
          {formStore.errors.columns.trackingVendorId && (
            <FormHelperText error>
              {formStore.errors.columns.trackingVendorId}
            </FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <AsyncButton onAwait={save}>保存</AsyncButton>
      </Grid>
    </Grid>
  ));
};
